// (B120-1; planning 10-27 14:10) the approved Terms of Service (legal-text.ts)
import { LegalPage } from "./LegalPage.tsx";
import { TERMS } from "./legal-text.ts";

export function TermsPage() {
  return <LegalPage title="Terms of Service" path="/terms" text={TERMS}
    description="TubeForge's terms of service: your account, your content, AI-generated videos and the services we use." />;
}
